import React from 'react'
import { User } from 'lucide-react'
import { Button } from '../components/ui/Button'
import useAuthStore from '../store/auth'
import { Link } from 'react-router-dom'

const ProfilePage = () => {
  const { isAuthenticated } = useAuthStore()

  if (!isAuthenticated) {
    return (
      <div className="text-center py-12">
        <div className="text-6xl mb-4">👤</div>
        <h2 className="text-2xl font-display font-bold text-gray-900 mb-4">
          Profile Access Required
        </h2>
        <p className="text-gray-600 mb-6">
          Sign in to access your profile and manage your recipes
        </p>
        <Button asChild>
          <Link to="/login">Sign In</Link>
        </Button>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="text-center py-12">
        <User className="w-16 h-16 mx-auto text-gray-300 mb-4" />
        <h2 className="text-2xl font-display font-bold text-gray-900 mb-4">
          Profile Coming Soon
        </h2>
        <p className="text-gray-600 mb-6">
          We're working on an amazing profile experience for you
        </p>
        <Button asChild>
          <Link to="/recipes">Browse Recipes</Link>
        </Button>
      </div>
    </div>
  )
}

export default ProfilePage